// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-window-item>.v-card[data-v-5ed84115]{min-height:300px}\n", "",{"version":3,"sources":["/app/app/javascript/packs/backyard/pages/deliveryCompanies/forms/_Tab.vue"],"names":[],"mappings":"AA0EA,wCAEE,gBAAgB","file":"_Tab.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.v-window-item > .v-card\n{\n  min-height:300px;\n}\n"]}]);
// Exports
module.exports = exports;
